<div class="step-info" [ngClass]="{'step-info--no-step-counter' : !showStepCounter}">
  <div *ngIf="showStepCounter" (click)="onStepCounterClick()" class="step-counter">
    {{ 'STEP_INFO_COMPONENT.step' | translate }} {{ currentStepNumber }} {{ 'STEP_INFO_COMPONENT.from' | translate }} {{ allStepsNumber }}
  </div>

  <app-send-offer
          [context]="offerNumberContext">
  </app-send-offer>
</div>
